import * as React from 'react';

const StatementIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <mask
        id='mask0_7799_21257'
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <path d='M24 0H0V24H24V0Z' fill='white' />
      </mask>
      <g mask='url(#mask0_7799_21257)'>
        <path
          d='M12 1.5C6.21 1.5 1.5 6.21 1.5 12C1.5 17.79 6.21 22.5 12 22.5C17.79 22.5 22.5 17.79 22.5 12C22.5 6.21 17.79 1.5 12 1.5ZM12 20.25C7.45083 20.25 3.75 16.5492 3.75 12C3.75 7.45083 7.45083 3.75 12 3.75C16.5492 3.75 20.25 7.45083 20.25 12C20.25 16.5492 16.5492 20.25 12 20.25Z'
          fill='#695F5F'
        />
        <path
          d='M10.875 17.25L13.125 18V10.5L10.875 9.75V17.25Z'
          fill='#695F5F'
        />
        <path d='M10.875 8.25L13.125 9V6.75L10.875 6V8.25Z' fill='#695F5F' />
      </g>
    </svg>
  );
};
export default StatementIcon;
